import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { trigger, style, animate, transition, query, group, state, stagger } from '@angular/animations'; //animations
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    trigger('routeAnimation', [
      transition('* <=> *', [
        query(':enter', style({ position: 'fixed', width: '100%', height: '100%' }), { optional: true }),
        group([
          query(':enter', [
            stagger(100, [
              style({ opacity: 0 }),
              animate('.6s ease-in-out', style({ opacity: 1 }))
            ])
          ], { optional: true }),
        ])
      ])
    ])
  ]
})
export class AppComponent implements OnInit {
  title = 'imobiliariav';

  constructor(
    private router: Router,
    @Inject(DOCUMENT) private document: any
  ) { }

  ngOnInit() {

  }

  getDepth(outlet) {
    return outlet.activatedRouteData.state;
  }

  routerEvent(event) {
    /* this.router.navigate(['/vitrine']); */
    this.router.navigate([event]);
  }

  gocall(){
    // https://api.whatsapp.com/send?phone=seunumerodetelefone&text=sua%20mensagem
    // (55) 9 9967-1627
    // this.document.location.href = encodeURI('https://api.whatsapp.com/send?phone=5555999671627&text=Olá, estou entrando em contato para...');

    (window as any).open(encodeURI('https://api.whatsapp.com/send?phone=5555999671627&text=Olá, estou entrando em contato para...'), "_blank");
  }
}
